import { useFormik } from "formik";
import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

import { Button } from "primereact/button";
import { FileUpload } from "primereact/fileupload";
import { Image } from "primereact/image";
import { Divider } from "primereact/divider";
import {
  getSetupDetails,
  updateContactSection,
} from "../../../store/AsyncMethods/SetupMethod";
import { toast } from "react-toastify";

export default function ManageContactSection() {
  const dispatch = useDispatch();
  const [contactImageUrl, setContactImageUrl] = useState(null);
  const [contactImage, setContactImage] = useState(null);
  const contactUploadRef = useRef(null);

  const navigate = useNavigate();
  const { setupDetails } = useSelector((state) => state.SetupReducer);

  const onContactImageUpload = () => {
    if (contactUploadRef.current) {
      const inputElement = contactUploadRef.current.getInput();
      inputElement?.click();
    }
  };

  const onContactImageSelect = (e) => {
    const file = e.files[0];

    if (!file) {
      toast.error("File is invalid or exceeding size");
      return;
    }

    setContactImageUrl(file);

    const url = URL.createObjectURL(file);
    setContactImage(url);
  };

  const statusOptions = [
    { name: "Enabled", value: 1 },
    { name: "Disabled", value: 0 },
  ];

  const formik = useFormik({
    initialValues: {
      contactImage: "",
    },

    onSubmit: async (data) => {
      const formData = new FormData();

      Object.keys(data).forEach((key) => {
        formData.append(key, data[key]);
      });

      if (contactImageUrl) {
        formData.append("contactImage", contactImageUrl);
      }

      dispatch(updateContactSection(formData)).then((success) => {
        if (success) {
          formik.resetForm();
          dispatch(getSetupDetails());
          navigate("/site-setup/contact-section");
        }
      });
    },
  });

  useEffect(() => {
    dispatch(getSetupDetails());
  }, []);

  return (
    <div className="mx-4">
      <form onSubmit={formik.handleSubmit}>
        <div className="card shadow-md rounded-lg p-4 mt-3">
          <Divider>
            <span className="text-2xl font-bold p-font-style text-center text-black mx-1">
              Customize Contact Section
            </span>
          </Divider>
          <Button
            onClick={() => {
              navigate("/site-setup");
            }}
            type="button"
            label="Back"
            icon="pi pi-arrow-left"
            className="  p-primary-highlight-btn mb-3"
          />

          <div className="px-4 gap-4">
            <div className="">
              <div className="flex flex-col gap-2 ">
                <label htmlFor="contactImage" className="">
                  Contact Image
                </label>
                <div className=" flex flex-col gap-2">
                  <Button
                    onClick={onContactImageUpload}
                    type="button"
                    label="Upload"
                    icon="pi pi-plus"
                    className="  p-primary-highlight-btn w-1/12"
                  />

                  <FileUpload
                    ref={contactUploadRef}
                    mode="basic"
                    name="contact-image-upload"
                    accept="image/*"
                    maxFileSize={5000000}
                    auto
                    onSelect={onContactImageSelect}
                    style={{ display: "none" }}
                  />
                  <small id="contact--image-upload-help">
                    Please upload a supported image file smaller than 5MB.
                  </small>

                  <div className="flex">
                    <div className="  overflow-hidden">
                      {contactImage ? (
                        <Image
                          src={contactImage}
                          alt="Uploaded Contact Image"
                          width="512"
                          height="512"
                          preview
                        />
                      ) : (
                        setupDetails?.contact_image && (
                          <Image
                            src={
                              setupDetails.logoPath + setupDetails.contact_image
                            }
                            alt="Uploaded Contact Image"
                            width="512"
                            height="512"
                            preview
                          />
                        )
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="mt-8">
          <div className="flex justify-end gap-4">
            <Button
              label="Clear"
              icon="pi pi-times"
              className="p-red-btn"
              type="button"
              onClick={() => {
                formik.resetForm();
              }}
            />
            <Button
              type="submit"
              label="Save"
              icon="pi pi-check"
              className="p-secondary-btn"
            />
          </div>
        </div>
      </form>
    </div>
  );
}
